import React from 'react';
import ReactDOM from 'react-dom';
import GlobalContextProvider from '../src/providers/global-context.provider';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { setNotification } from './services/notification.service';
import { getCookie } from './utils/cookie';

import { getMessaging, getToken } from "firebase/messaging";
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAFLwXStJ5caTDtmEv3hOyq4NtQG5Ds1No",
    authDomain: "bndb-190a6.firebaseapp.com",
    databaseURL: "https://bndb-190a6.firebaseio.com",
    projectId: "bndb-190a6",
    storageBucket: "bndb-190a6.appspot.com",
    messagingSenderId: "118839167879",
    appId: "1:118839167879:web:5ef1369c6ac13cc7d0e122",
    measurementId: "G-8D4C7BZ6ZL"
};


ReactDOM.render(
	<GlobalContextProvider>
		<BrowserRouter>
			<App />
		</BrowserRouter>{' '}
	</GlobalContextProvider>,
	document.getElementById('root')
);


serviceWorker.register();

setTimeout(() => {
	
	try {
		
		const token = getCookie('x-auth-token');
		// console.log('token', token);
		if(token!=null) {
			const app = initializeApp(firebaseConfig);
			const messaging = getMessaging();
			getToken(messaging, { vapidKey: 'BGSOpQR1b2PHCY8AU_LF2vvLZg_rfCT1JgyXkTFoZtRSyJWLqnFtniKlkCBsF52kHfmqS27V_hmRBKGUNsM3s_k' })
			.then((currentToken) => {
				if (currentToken) {
					setNotification(token,{ Token: currentToken});
				} else {
					console.log('No registration token available. Request permission to generate one.');
				}
			}).catch((err) => {
				console.log('An error occurred while retrieving token. ', err);
			});
		}
		
	} catch (error) {
		console.error(error);
	}

// const analytics = getAnalytics(app);
}, 1000);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

